/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }s
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";

import { authGuard } from "./auth";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [{
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "home",
          component: () => import("./views/Home.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "Accueil",
            //requiresAuth: true
          }
        },
        {
          path: "/messagerie",
          name: "messagerie",
          component: () => import("./views/messagerie/Messagerie.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "Messagerie",
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Messagerie",
                active: true
              }
            ]
          }
        },
        {
          path: "/messagerie/:clientId",
          name: "messagerieClient",
          component: () => import("./views/messagerie/Messagerie.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "Messagerie",
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Messagerie",
                active: true
              }
            ]
          }
        },
        {
          path: "/stats",
          name: "stats",
          component: () => import("./views/Stats.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "",
            //requiresAuth: true
          }
        },
        {
          path: "/data/fec",
          name: "fecdata",
          component: () => import("./views/data/fec.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Données FEC Pennylane",
                active: true
              }
            ],
            pageTitle: ""
          }
        },
        {
          path: "/data/apikeys",
          name: "comptaapikeys",
          component: () => import("./views/data/apikeys.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Clés API logiciels comptables",
                active: true
              }
            ],
            pageTitle: ""
          }
        },
        /* {
          path: "/temp",
          name: "home2",
          component: () => import("./views/Home2.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "",
            //requiresAuth: true
          }
        }, */
        {
          path: "/contacts/listing",
          name: "mesclients",
          component: () => import("./views/clients/Listing.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Contacts",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/contacts/nouveau",
          name: "nouveauclient",
          component: () => import("./views/clients/NouveauClient.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Contacts",
                url: "/contacts/listing"
              },
              {
                title: "Nouveau contact",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/contacts/nouveau/personnemorale",
          name: "nouveauclientpm",
          component: () => import("./views/clients/NouveauClientPM.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Contacts",
                url: "/contacts/listing"
              },
              {
                title: "Nouveau contact",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/contacts/personnemorale/fiche/:id",
          name: "fichePM",
          component: () => import("./views/clients/FichePM.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Contacts",
                url: "/contacts/listing"
              },
              {
                title: "Fiche personne morale",
                active: true
              }
            ],
            pageTitle: "Fiche personne morale"
          }
        },
        {
          path: "/contacts/modifier/personnemorale/:id",
          name: "editclientpm",
          component: () => import("./views/clients/NouveauClientPM.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Contacts",
                url: "/contacts/listing"
              },
              {
                title: "Modifier un contact",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/contacts/modifier/:id",
          name: "modifierclient",
          component: () => import("./views/clients/ModificationClient.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Contacts",
                url: "/contacts/listing"
              },
              {
                title: "Modification",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/contacts/import",
          name: "importclient",
          component: () => import("./views/clients/Import.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Contacts",
                url: "/contacts/listing"
              },
              {
                title: "Import de contacts",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/documents/nouveau",
          name: "nouveaufichier",
          component: () => import("./views/ged/Upload.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Documents clients",
                url: "/documents/listing"
              },
              {
                title: "Nouveaux documents",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/dossiers/listing",
          name: "mesdossiers",
          component: () => import("./views/dossiers/Listing.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Dossiers clients",
                active: true
              }
            ],
            /* requiresAuth: true */
          }
        },
        {
          path: "/bilans/listing",
          name: "mesbilans",
          component: () => import("./views/dossiers/Bilans.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Dossiers clients",
                url: "/dossiers/listing"
              },
              {
                title: "Etudes patrimoniales",
                active: true
              }
            ],
            /* requiresAuth: true */
          }
        },
        {
          path: "/bilans/listing/:id",
          name: "bilansclient",
          component: () => import("./views/dossiers/Bilans.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Dossiers clients",
                url: "/dossiers/listing"
              },
              {
                title: "Etudes patrimoniales",
                active: true
              }
            ],
           /*  requiresAuth: true */
          }
        },
        {
          path: "/bilans/nouveau",
          name: "nouveaubilan",
          component: () => import("./views/dossiers/NouveauBilan.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Dossiers clients",
                url: "/dossiers/listing"
              },
              {
                title: "Nouvelle étude",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/dossiers/recueil/:id",
          name: "receuildossier",
          component: () => import("./views/dossiers/Recueil.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Dossiers clients",
                url: "/dossiers/listing"
              },
              {
                title: "Recueil d'information",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/dossiers/audit/:id",
          name: "auditpatrimonial",
          component: () => import("./views/dossiers/Audit.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Dossiers clients",
                url: "/dossiers/listing"
              },
              {
                title: "Situation patrimoniale",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/dossiers/recueil/:id",
          name: "receuildossierchoix",
          component: () => import("./views/dossiers/ChoixClient.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Dossiers clients",
                url: "/dossiers/listing"
              },
              {
                title: "Recueil d'information",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/administration/affilies/listing",
          name: "affilieslisting",
          component: () => import("./views/administration/Affilies.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Affiliés",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },
        {
          path: "/administration/partage/autorisations",
          name: "partageAllowances",
          component: () => import("./views/administration/PartageAllowances.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [
              { title: "Accueil", url: "/" },
              { title: "Administration", active: false },
              { title: "Autorisations de partage", active: true }
            ],
            pageTitle: ""
          }
        },
        {
          path: "/administration/partage/demandes",
          name: "partageRequests",
          component: () => import("./views/administration/PartageRequests.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [
              { title: "Accueil", url: "/" },
              { title: "Administration", active: false },
              { title: "Demandes de partage", active: true }
            ],
            pageTitle: ""
          }
        },
        {
          path: "/administration/EntreeEnRelation/listing",
          name: "entreeEnRelationlisting",
          component: () => import("./views/administration/EntreeEnRelation.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Entrée en relation",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },
        {
          path: "/administration/EntreeEnRelation/nouveau/:id",
          name: "affiliesAddAdmin",
          component: () => import("./views/administration/AddAffilie.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Nouvel affilié",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },
        {
          path: "/administration/EntreeEnRelation/modifier/:id",
          name: "affiliesEditAdmin",
          component: () => import("./views/administration/AddAffilie.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Modifier un affilié",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },
        {
          path: "/administration/utilisateurs/listing",
          name: "utilisateurslisting",
          component: () => import("./views/administration/Users.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Utilisateurs",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },
        {
          path: "/administration/utilitaires/actualites",
          name: "actualitesmahaka",
          component: () => import("./views/utilitaires/Actualites.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Utilitaires",
                active: true
              },
              {
                title: "Actualités",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },        
        {
          path: "/administration/utilitaires/evenements",
          name: "evenementsmahaka",
          component: () => import("./views/utilitaires/Events.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Utilitaires",
                active: true
              },
              {
                title: "Événements",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },     
        {
          path: "/administration/utilitaires/informations",
          name: "infosmahaka",
          component: () => import("./views/utilitaires/Infos.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Utilitaires",
                active: true
              },
              {
                title: "Informations",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },       
        {
          path: "/administration/utilitaires/produits",
          name: "utilitairesProduits",
          component: () => import("./views/utilitaires/Produits.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Utilitaires",
                active: true
              },
              {
                title: "Produits",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },        
        {
          path: "/administration/utilitaires/partenaires",
          name: "utilitairesPartenaires",
          component: () => import("./views/utilitaires/Partners.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Utilitaires",
                active: true
              },
              {
                title: "Partenaires",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },    
        {
          path: "/administration/affilies/modifier/:id",
          name: "affiliesValidEditAdmin",
          component: () => import("./views/administration/AddAffilie.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Modification de l'affilié",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },
        {
          path: "/administration/contrat/afficher/:id",
          name: "ContratAffiliationDisplayAdmin",
          component: () => import("./views/administration/ContratAffiliationDisplay.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Contrat d'affiliation",
                active: false
              },
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/Obligations/ProfilRisques/edition/:id",
          name: "profilRisquesAddAdmin",
          component: () => import("./views/obligations/ProfilRisques.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Profil de risque",
                active: true
              },
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/Obligations/ProfilRisques/afficher/:id",
          name: "profilRisquesDisplayAdmin",
          component: () => import("./views/obligations/ProfilRisquesDisplay.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Profil de risque",
                active: false
              },
              {
                title: "Afficher le profil de risque",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/Obligations/LettreMission/nouveau/:id",
          name: "LettreMissionAddAdmin",
          component: () => import("./views/obligations/LettreMission.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Lettre de mission",
                active: false
              },
              {
                title: "Nouvelle lettre de mission",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/Obligations/LettreMission/modifier/:id/:lettreId",
          name: "LettreMissionEditAdmin",
          component: () => import("./views/obligations/LettreMission.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Lettre de mission",
                active: false
              },
              {
                title: "Modifier la lettre de mission",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/Obligations/LettreMission/afficher/:id",
          name: "LettreMissionDisplayAdmin",
          component: () => import("./views/obligations/LettreMissionDisplay.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Lettre de mission",
                active: false
              },
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/Obligations/LettreMission/choix/:id",
          name: "LettreMissionOnBoarding",
          component: () => import("./views/obligations/LettreMissionOnBoarding.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Lettre de mission",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/Obligations/DER/choix/:id",
          name: "DerOnBoarding",
          component: () => import("./views/obligations/DerOnBoarding.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Document d'entrée en relation",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/Obligations/DER/afficher/:id",
          name: "DerDisplayAdmin",
          component: () => import("./views/obligations/DerDisplay.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Document d'entrée en relation",
                active: false
              },
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/Obligations/DER/editer/:id",
          name: "DerEdit",
          component: () => import("./views/obligations/DerEdit.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Document d'entrée en relation",
                active: true
              }
            ],
            pageTitle: "",
          }
        },
        {
          path: "/administration/der-modele",
          name: "derTemplateEditor",
          component: () => import("./views/administration/DerTemplateEditor.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Modèle DER",
                active: true
              }
            ],
            pageTitle: "Modèle DER",
            requiresSuperAdmin: true
          }
        },
        {
          path: "/parametrage/documents-reglementaires",
          name: "parametrageDocumentsReglementaires",
          component: () => import("./views/parametrage/DocumentsReglementaires.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Paramétrage",
                url: "/parametrage/documents-reglementaires"
              },
              {
                title: "Documents réglementaires",
                active: true
              }
            ],
            pageTitle: "Paramétrage des documents réglementaires"
          }
        },
        {
          path: "/documents/listing/",
          name: "mesfichiers",
          component: () => import("./views/ged/Listing.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Dossiers clients",
                url: "/dossiers/listing"
              },
              {
                title: "Documents clients",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/documents/listing/:id",
          name: "fichiersclient",
          component: () => import("./views/ged/Listing.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Dossiers clients",
                url: "/dossiers/listing"
              },
              {
                title: "Documents clients",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/taches",
          redirect: '/taches/all'
        },
        {
          path: '/taches/:filter',
          name: 'taches',
          component: () => import('./views/taches/Todo.vue'),
          beforeEnter: authGuard,
          meta: {
            rule: 'editor',
            parent: "todo",
            /* requiresAuth: true */
          }
        },
        {
          path: '/basedocumentaire',
          name: 'basedocumentaire',
          component: () => import('./views/basedocumentaire/basedocumentaire.vue'),
          beforeEnter: authGuard,
          meta: {
           
          }, 
          props: (route) => ({ recherche: route.query.recherche }), 
        },
        {
          path: '/basedocumentaire/:cat/:id',
          name: 'basedocumentaireSousCat',
          component: () => import('./views/basedocumentaire/SousCategories.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
              title: "Accueil",
              url: "/"
            },
            {
              title: "Base documentaire",
              url: "/basedocumentaire"
            },
            {
              title: "",
              active: true
            }
          ],
          pageTitle: "",
          }
        },
        {
          path: '/basedocumentaire/article/:id',
          name: 'basedocumentairearticlet',
          component: () => import('./views/basedocumentaire/Article.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
              title: "Accueil",
              url: "/"
            },
            {
              title: "Base documentaire",
              url: "/basedocumentaire"
            },
            {
              title: "",
              active: true
            }
          ],
          pageTitle: "",
          }
        },
        /* {
          path: '/basedocumentaire/:recherche',
          name: 'basedocumentaireRecherche',
          component: () => import('./views/basedocumentaire/basedocumentaire.vue'),
          beforeEnter: authGuard,
          meta: {            
          }
        }, */
        {
          path: "/apicil/souscription",
          name: "choixsouscriptionapicil",
          component: () => import("./views/AssuranceVie/Apicil/ChoixClient.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true */
          }
        },
        {
          path: "/apicil/signature/:id",
          name: "signatureapicil",
          component: () => import("./views/AssuranceVie/Apicil/Signature.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true */
          }
        },
        /* {
          path: "/apicil/details/:id",
          name: "apicildetails",
          component: () => import("./views/AssuranceVie/Apicil/Details.vue"),
          beforeEnter: authGuard,
          meta: {
            
          }
        }, */
        {
          path: "/apicil/souscription/:id",
          name: "souscriptionapicil",
          component: () => import("./views/AssuranceVie/Apicil/Apicil.vue"),
          beforeEnter: authGuard,
          meta: {
           /*  requiresAuth: true */
          }
        },
        {
          path: "/apicil/details/:id",
          name: "detailssouscriptionapicil",
          component: () => import("./views/AssuranceVie/Apicil/ApicilDetails.vue"),
          beforeEnter: authGuard,
          meta: {
           /*  requiresAuth: true */
          }
        },
        {
          path: "/apicil/documents/:id",
          name: "PiecesJustificatives",
          component: () => import("./views/AssuranceVie/Apicil/PiecesJustificatives.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true */
          }
        },
        {
          path: "/pages/contact",
          name: "Contact",
          component: () => import("./views/pages/Contact.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true */
          }
        },
        {
          path: "/invest/produits",
          name: "invest",
          component: () => import("./views/invest/invest.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true */
          }
        },
        {
          path: "/commissions/bordereaux",
          name: "commissions",
          component: () => import("./views/commissions/Commissions.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true */
          }
        },
        {
          path: "/commissions/retrocessions",
          name: "retrocomm",
          component: () => import("./views/commissions/RetroComm.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true */
          }
        },
        {
          path: "/commissions/paiements",
          name: "paiementscomm",
          component: () => import("./views/commissions/PaiementsCommissions.vue"),
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/commissions/received-files",
          name: "receivedretrocommissionfiles",
          component: () => import("./views/commissions/ReceivedRetroCommissionsFiles.vue"),
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/commissions/received-lines",
          name: "receivedretrocommissionlines",
          component: () => import("./views/commissions/ReceivedRetroCommissionsLines.vue"),
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/commissions/received-mappings",
          name: "receivedretrocommissionmappings",
          component: () => import("./views/commissions/ReceivedRetroCommissionTenantMappings.vue"),
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/commissions/received-client-mappings",
          name: "receivedretrocommissionclientmappings",
          component: () => import("./views/commissions/ReceivedRetroCommissionClientMappings.vue"),
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/invest/listing",
          name: "investlisting",
          component: () => import("./views/invest/listing.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true */
          }
        },
        {
          path: "/invest/listing/:id",
          name: "investclient",
          component: () => import("./views/invest/listing.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true */
          }
        },
        {
          path: "/invest/immo",
          name: "investimmo",
          component: () => import("./views/invest/immo.vue"),
          beforeEnter: authGuard,
          
        }, 
        {
          path: "/invest/bien/:id",
          name: "investbien",
          component: () => import("./views/invest/bien.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "Investissement immobilier",
            /* requiresAuth: true */
          }
        },
        {
          path: "/invest/assurance-vie",
          name: "investassvie",
          component: () => import("./views/invest/assuvie.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "Souscription de produits financiers",
            /* requiresAuth: true */
          }
        },        
        {
          path: "/immobilier",
          name: "immoprojects",
          component: () => import("./views/immobilier/ListingProjects.vue"),
          beforeEnter: authGuard,
          
        }, 
        {
          path: "/signatures/listing/",
          name: "messignatures",
          component: () => import("./views/signatures/Listing.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Liste des signatures électroniques",
                active: true
              }
            ],
            /* requiresAuth: true */
          }
        },
        {
          path: "/signatures/listing/:id",
          name: "signaturesclient",
          component: () => import("./views/signatures/Listing.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Liste des signatures électroniques",
                url: "/signatures/listing"
              },
              {
                title: "Signatures électronique client",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },        
        {
          path: "/signatures/envoyer/:id",
          name: "envoyersignature",
          component: () => import("./views/signatures/SendSignFile.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Envoyer en signature électronique",
                active: false
              },
            ],
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/simulations/listing/",
          name: "messimulations",
          component: () => import("./views/simulations/Listing.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Liste des simulations",
                active: true
              }
            ],
            /* requiresAuth: true */
          }
        },
        {
          path: "/simulations/mako/:id/:sim/:rand",
          name: "makoredirect",
          component: () => import("./views/simulations/MakoRedirect.vue"),
          beforeEnter: authGuard,
        },
        {
          path: "/simulations/plp/:id/:sim/:rand",
          name: "plpRedirect",
          component: () => import("./views/simulations/PlpRedirect.vue"),
          beforeEnter: authGuard,
        },
        {
          path: "/simulations/listing/:id",
          name: "simulationsclient",
          component: () => import("./views/simulations/Listing.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Liste des simulations",
                active: true
              }
            ],
            /* requiresAuth: true */
          }
        },
        {
          path: "/simulations/:id",
          name: "simulateurs",
          component: () => import("./views/simulations/Simulations.vue"),
          beforeEnter: authGuard,
          meta: {
            /* requiresAuth: true, */
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Simulations",
                url: "/simulations",
                active: true
              }
            ],
          }
        },
        {
          path: "/simulateurs",
          name: "simulationschoix",
          component: () => import("./views/simulations/ChoixClient.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/account/monmotdepasse",
          name: "monmotdepasse",
          component: () => import("./views/account/change-password.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: "/account/changementtenant",
          name: "changementtenant",
          component: () => import("./views/account/change-tenant.vue"),
          beforeEnter: authGuard,
          meta: {
            pageTitle: "",
            /* requiresAuth: true */
          }
        },
        {
          path: '/administration/StatSignatures',
          name: 'statSignatures',
          component: () => import('./views/administration/EsigStats.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Signatures éléctoniques",
                active: true
              },
              {
                title: "Statistiques",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        },
        /* {
          path: '/aggregation',
          name: 'aggregation',
          component: () => import('./views/aggregation/Listing.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Aggrégation de comptes",
                active: true
              },
            ],
            pageTitle: "",
            requiresSuperAdmin: false
          }
        }, */
        {
          path: '/conformite/ReclamationsClients',
          name: 'reclamationsclients',
          component: () => import('./views/conformite/ReclamationsClients.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Traitement des réclamations de mes clients",
                active: true
              },
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: false
          }
        },
        {
          path: '/conformite/Incidents',
          name: 'incidents',
          component: () => import('./views/conformite/Incidents.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Conformité",
                active: false
              },
              {
                title: "Traitement des incidents",
                active: true
              },
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: false
          }
        },
        {
          path: '/conformite/Procedures',
          name: 'procedures',
          component: () => import('./views/conformite/Procedures.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Conformité",
                active: false
              },
              {
                title: "Procédures",
                active: true
              },
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: false
          }
        },
        {
          path: '/conformite/procedures/lcbft/:id?',
          name: 'procedureLcbft',
          component: () => import('./views/conformite/ProcedureLcbft.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Conformité",
                active: false
              },
              {
                title: "Procédures",
                url: "/conformite/Procedures"
              },
              {
                title: "Procédure LCB-FT",
                active: true
              },
            ],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/procedures/gouvprod/:id?',
          name: 'procedureGouvprod',
          component: () => import('./views/conformite/ProcedureGouvprod.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Conformité",
                active: false
              },
              {
                title: "Procédures",
                url: "/conformite/Procedures"
              },
              {
                title: "Gouvernance produit",
                active: true
              },
            ],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/procedures/conflits/:id?',
          name: 'procedureConflits',
          component: () => import('./views/conformite/ProcedureConflits.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Procédures", url: "/conformite/Procedures" }, { title: "Conflits d'intérêts", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/procedures/reclam/:id?',
          name: 'procedureReclam',
          component: () => import('./views/conformite/ProcedureReclam.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Procédures", url: "/conformite/Procedures" }, { title: "Réclamations", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/procedures/doccom/:id?',
          name: 'procedureDoccom',
          component: () => import('./views/conformite/ProcedureDoccom.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Procédures", url: "/conformite/Procedures" }, { title: "Documentation commerciale", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/procedures/deonto/:id?',
          name: 'procedureDeonto',
          component: () => import('./views/conformite/ProcedureDeonto.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Procédures", url: "/conformite/Procedures" }, { title: "Incidents et alerte éthique", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/procedures/rgpd/:id?',
          name: 'procedureRgpd',
          component: () => import('./views/conformite/ProcedureRgpd.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Procédures", url: "/conformite/Procedures" }, { title: "Données personnelles (RGPD)", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/risques-clients',
          name: 'lcbftRisqueClients',
          component: () => import('./views/conformite/LcbftRisqueClients.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Risques clients LCB-FT", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/cartographie-lcbft',
          name: 'lcbftCartographie',
          component: () => import('./views/conformite/LcbftCartographie.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Cartographie LCB-FT", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/lcbft-risque/:id',
          name: 'lcbftQuestionnaire',
          component: () => import('./views/conformite/LcbftQuestionnaire.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Risques clients LCB-FT", url: "/conformite/risques-clients" }, { title: "Questionnaire", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/alertes-gel',
          name: 'sanctionAlerts',
          component: () => import('./views/conformite/SanctionAlerts.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Gel des avoirs", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/screening/:id',
          name: 'sanctionScreening',
          component: () => import('./views/conformite/SanctionScreening.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Conformité", active: false }, { title: "Gel des avoirs", url: "/conformite/alertes-gel" }, { title: "Criblage", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/administration/listes-sanctions',
          name: 'sanctionsLists',
          component: () => import('./views/administration/SanctionsLists.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{ title: "Accueil", url: "/" }, { title: "Administration", active: false }, { title: "Listes de sanctions", active: true }],
            pageTitle: "",
          }
        },
        {
          path: '/conformite/ConflitsInterets',
          name: 'conflitsInterets',
          component: () => import('./views/conformite/ConflitsInterets.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Conformité",
                active: false
              },
              {
                title: "Conflits d'intérêts",
                active: true
              },
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: false
          }
        },
        {
          path: '/pilotage/SuiviDossiers',
          name: 'suiviDossiers',
          component: () => import('./views/pilotage/SuiviDossiers.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Pilotage",
                active: false
              },
              {
                title: "Suivi d'activité",
                active: true
              },
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: false
          }
        },
        {
          path: '/pilotage/SuiviProduction',
          name: 'SuiviProduction',
          component: () => import('./views/pilotage/SuiviProduction.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Pilotage",
                active: false
              },
              {
                title: "Suivi de la production",
                active: true
              },
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: false
          }
        },
        {
          path: '/pilotage/Souscripteurs',
          name: 'Souscripteurs',
          component: () => import('./views/pilotage/Souscripteurs.vue'),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Pilotage",
                active: false
              },
              {
                title: "Gestion des souscripteurs",
                active: true
              },
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: false
          }
        },
        {
          path: "/administration/basedocumentaire/articles",
          name: "articlesbasedocumentairemahaka",
          component: () => import("./views/basedocumentaire/ArticleListing.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Base documentaire",
                active: true,
                url: "/basedocumentaire"
              },
              {
                title: "Articles",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        }, 
        
        {
          path: "/administration/basedocumentaire/article/Ajouter",
          name: "articleaddbasedocumentairemahaka",
          component: () => import("./views/basedocumentaire/AddArticle.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Base documentaire",
                active: true,
                url: "/basedocumentaire"
              },
              {
                title: "Ajouter un article",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        }, 
        {
          path: "/administration/basedocumentaire/categories",
          name: "categoriesbasedocumentairemahaka",
          component: () => import("./views/basedocumentaire/Categories.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Administration",
                active: false
              },
              {
                title: "Base documentaire",
                active: true,
                url: "/basedocumentaire"
              },
              {
                title: "Catégories",
                active: true
              }
            ],
            pageTitle: "",
            /* requiresAuth: true, */
            requiresSuperAdmin: true
          }
        }, 
        {
          path: "/calculs/commissions",
          name: "calculscommissions",
          component: () => import("./views/calculettes/commissions.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Calculs",
                active: false
              },
              {
                title: "Commissions",
                active: true
              },
            ],
            pageTitle: "",
          }
        },   
        {
          path: "/reglementaire/formations",
          name: "formationsreglementaires",
          component: () => import("./views/Reglementaire/Formations.vue"),
          beforeEnter: authGuard,
          meta: {
            breadcrumb: [{
                title: "Accueil",
                url: "/"
              },
              {
                title: "Formations",
                active: true
              },
            ],
            pageTitle: "",
          }
        },   
        /* {
          path: "/simulations/rem",
          name: "rem",
          component: () => import("./views/simulations/Rem.vue"),
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "/simulations/PrevTns",
          name: "PrevTns",
          component: () => import("./views/simulations/PrevTns.vue"),
          meta: {
            requiresAuth: true
          }
        }, {
          path: "/simulations/bilanretraite",
          name: "bilanretraite",
          component: () => import("./views/simulations/Bilanretraite.vue"),
          meta: {
            requiresAuth: true
          }
        } */
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================               
        {
          path: "/pages/error-404",
          name: "pageError404",
          component: () => import("@/views/pages/Error404.vue")
        },
        {
          path: "/affiliation/",
          name: "affiliesAddOwn",
          component: () => import("./views/administration/AddAffilie.vue"),
          beforeEnter: authGuard,
          meta: {
            guest: true,
            requiresSingleAuth: true,
            pageTitle: ""
          }
        },
        {
          path: "/affiliation/:id",
          name: "affiliesAddOwnId",
          component: () => import("./views/administration/AddAffilie.vue"),
          beforeEnter: authGuard,
          meta: {
            guest: true,
            requiresSingleAuth: true,
            pageTitle: ""
          }
        },
        {
          path: "/profilderisques",
          name: "profilRisquesAddOwn",
          component: () => import("./views/obligations/ProfilRisques.vue"),
          meta: {
            guest: true,
            requiresSingleAuth: true,
            pageTitle: ""
          }
        },
        {
          // Public sharing form. No authGuard: access is gated in-component by email + 6-digit code.
          path: "/Partage/:tenantId",
          name: "partageForm",
          component: () => import("./views/partage/PartageForm.vue"),
          meta: {
            guest: true,
            pageTitle: ""
          }
        },
      ]
    },
    {
      path: "/pages/test",
      name: "test",
      component: () => import("@/views/pages/test.vue")
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
export default router;
